var map = {
	"./CompetitionEmptyDefaultLayout": [
		"2820",
		"chunk-2d0b33fa"
	],
	"./CompetitionEmptyDefaultLayout.vue": [
		"2820",
		"chunk-2d0b33fa"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "b7e6";
module.exports = webpackAsyncContext;